var React = require('react');

function Ng (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"#fff","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#008753","d":"M426.6 0H640v480H426.6zM0 0h213.3v480H0z","key":1})]));
}

Ng.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Ng;

Ng.default = Ng;
